module.exports = __webpack_public_path__ + "img/3.8d99d6cd.svg";